import React from "react";
import Pagination from "react-bootstrap/Pagination";

const Paginate = ({ currentPage, paginate, totalRequestInPage }) => {
  return (
    <Pagination size="lg" className="justify-content-center">
      <Pagination.First onClick={() => paginate(1)} />
      {currentPage === 1 ? (
        ""
      ) : (
        <Pagination.Ellipsis onClick={() => paginate(currentPage - 1)}>
          Previous
        </Pagination.Ellipsis>
      )}

      <Pagination.Item className="active">{currentPage}</Pagination.Item>
      {totalRequestInPage < 10 ? (
        ""
      ) : (
        <Pagination.Item onClick={() => paginate(currentPage + 1)}>
          Next
        </Pagination.Item>
      )}
      <Pagination.Last disabled />
    </Pagination>
  );
};

export default Paginate;
